(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/test-utils.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/test-utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const testUtils = _ref => {
  let {
    screen,
    ComponentToTest,
    render,
    waitFor
  } = _ref;
  let fakeServer, userStub, openGameStub, closeGameStub, loggedInStub, accountBalanceGetStub, clock, resultDialogStub, resultDialogDemoStub, showGameClosedDialogStub, sendAnalyticsStub, jupiterCallAsyncStub, trackChooseNewTicketStub, trackEventSpy, fetchGuidesStub, confirmPause24Stub, ticketUtilityErrorLogger, ticketUtilityInfoLogger, ticketUtilityWarnLogger, apiErrorsStub, showDialogStub;
  svs.core.data.capabilities.channel = 'web-desktop';
  const beforeStubs = () => {
    fakeServer = nise.fakeServer.create();
    fakeServer.respondWith('GET', '/server/player/1/sessionstoreitems/trinidad_user', JSON.stringify({}));
    clock = sinon.useFakeTimers();
    userStub = sinon.stub(svs.tur.usersettings, 'get').returns($.Deferred().resolve({
      value: true
    }));
    loggedInStub = sinon.stub(svs.core.userSession, 'hasRole').returns(true);
    accountBalanceGetStub = sinon.stub(svs.components.account_balance, 'get').returns(true);
    const guides = [{
      tabName: 'Spelguide',
      active: true,
      order: 0,
      body: '<p>Spelguide</p>'
    }, {
      tabName: 'Vinstplan',
      active: false,
      order: 1,
      body: '<p>Vinstplan</p>'
    }];
    fetchGuidesStub = sinon.stub(svs.ticketgames.ticketUtility.utils, 'fetchGuides').returns(guides);
    confirmPause24Stub = sinon.stub(svs.tur.pause24, 'confirmPause24').returns(true);
    if (!gameloaderHelper.instance) {
      gameloaderHelper.instance = {
        notifierProxy: {
          notifySoundStatus: () => () => {}
        }
      };
    }
    jupiterCallAsyncStub = sinon.stub(svs.core.jupiter, 'callAsync').returns(new Promise(res => res));
    return {
      fakeServer,
      userStub,
      openGameStub,
      loggedInStub,
      accountBalanceGetStub,
      clock,
      resultDialogStub,
      resultDialogDemoStub,
      jupiterCallAsyncStub,
      fetchGuidesStub,
      confirmPause24Stub
    };
  };
  const afterStubs = () => {
    fakeServer.restore();
    clock.restore();
    loggedInStub.restore();
    accountBalanceGetStub.restore();
    userStub.restore();
    jupiterCallAsyncStub.restore();
    fetchGuidesStub.restore();
    confirmPause24Stub.restore();
  };
  const beforeEachStubs = () => {
    resultDialogStub = sinon.stub(svs.ticketgames.ticketUtility.utils.resultDialog, 'resultDialogNormal').returns(true);
    resultDialogDemoStub = sinon.stub(svs.ticketgames.ticketUtility.utils.resultDialog, 'resultDialogDemo').returns(true);
    openGameStub = sinon.stub(gameloaderHelper, 'openGame').returns(true);
    closeGameStub = sinon.stub(gameloaderHelper, 'closeGame').returns(true);
    showGameClosedDialogStub = sinon.stub(svs.ticketgames.ticketUtility.utils, 'showGameClosedDialog').returns(true);
    showDialogStub = sinon.stub(svs.ticketgames.ticketUtility.utils, 'showDialog').returns(true);
    sendAnalyticsStub = sinon.spy(svs.ticketgames.ticketUtility.utils.tracking, 'sendAnalytics');
    trackChooseNewTicketStub = sinon.spy(svs.ticketgames.ticketUtility.utils.tracking, 'trackChooseNewTicket');
    ticketUtilityErrorLogger = sinon.stub(svs.ticketgames.ticketUtility.logger, 'error').returns(true);
    ticketUtilityInfoLogger = sinon.stub(svs.ticketgames.ticketUtility.logger, 'info').returns(true);
    ticketUtilityWarnLogger = sinon.stub(svs.ticketgames.ticketUtility.logger, 'warn').returns(true);
    apiErrorsStub = sinon.stub(svs.tur.apierrors, 'showErrorMessage').returns(true);
    trackEventSpy = sinon.spy(svs.components.analytics, 'trackEvent');
    return {
      resultDialogStub,
      resultDialogDemoStub,
      showGameClosedDialogStub,
      showDialogStub,
      openGameStub,
      sendAnalyticsStub,
      trackChooseNewTicketStub,
      ticketUtilityErrorLogger,
      ticketUtilityInfoLogger,
      ticketUtilityWarnLogger,
      apiErrorsStub,
      trackEventSpy
    };
  };
  const afterEachStubs = () => {
    openGameStub.restore();
    closeGameStub.restore();
    showGameClosedDialogStub.restore();
    showDialogStub.restore();
    resultDialogStub.restore();
    resultDialogDemoStub.restore();
    sendAnalyticsStub.restore();
    trackChooseNewTicketStub.restore();
    trackEventSpy.restore();
    ticketUtilityErrorLogger.restore();
    ticketUtilityInfoLogger.restore();
    ticketUtilityWarnLogger.restore();
    apiErrorsStub.restore();
  };
  const testOpenGame = _ref2 => {
    let {
      ticketInfo,
      gameSpecificParameters = {
        skinId: 1,
        lockProgress: false
      },
      wagerId,
      gameMode = 'NORMAL',
      lotteryChannel = 'WEB,desktop',
      shouldOpenGame = true
    } = _ref2;
    if (shouldOpenGame) {
      const actual = openGameStub.getCalls(0)[0].firstArg;
      delete actual.hostChannel;
      delete actual.parentNode;
      const expected = {
        crossDomain: {
          hostKey: undefined,
          authorizedHosts: [window.location.host]
        },
        gameloader: {
          url: undefined,
          name: 'FGS_BRIDGE',
          betId: wagerId,
          gameMode,
          lotteryChannel,
          gameSpecificParameters: _objectSpread(_objectSpread({}, gameSpecificParameters), {}, {
            lockProgress: svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)
          }),
          theme: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.theme,
          soundEnabled: ticketInfo.hasSound && ticketInfo.hasSoundDefaultOn
        }
      };
      should(actual).eql(expected, 'openGame should be called with correct arguments');
    } else {
      should(openGameStub.called).eql(false, 'openGame should not be called');
    }
  };
  const renderGame = function (data) {
    let aborted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const renderFuncs = render(React.createElement(ComponentToTest, data));
    const {
      container
    } = renderFuncs;
    if (aborted) {
      return renderFuncs;
    }
    should(Boolean(container.querySelector('[data-testid="loader-ticket"]'))).eql(true);
    window.dispatchEvent(new Event('GAME_LOADING'));
    should(Boolean(container.querySelector('[data-testid="loader-ticket"]'))).eql(false);
    screen.getByRole('link', {
      name: /spelpaus24/i
    });
    screen.getByRole('link', {
      name: /självtest/i
    });
    return renderFuncs;
  };
  const renderGameAsync = async function (data) {
    let aborted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const renderFuncs = render(React.createElement(ComponentToTest, data));
    const {
      container
    } = renderFuncs;
    if (aborted) {
      return renderFuncs;
    }
    await waitFor(() => {});
    should(Boolean(container.querySelector('[data-testid="loader-ticket"]'))).eql(true);
    window.dispatchEvent(new Event('GAME_LOADING'));
    should(Boolean(container.querySelector('[data-testid="loader-ticket"]'))).eql(false);
    screen.getByRole('link', {
      name: /spelpaus24/i
    });
    screen.getByRole('link', {
      name: /självtest/i
    });
    return renderFuncs;
  };
  const dispatchCustomEvent = function (eventName) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const ev = new Event(eventName);
    ev.detail = data;
    window.dispatchEvent(ev);
  };
  const testBetId = function (data) {
    let demo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    dispatchCustomEvent('HAS_BET', data);
    screen.getByText(demo ? 'PROVSPEL' : "ID ".concat(data.data.id));
  };
  const testTopbarActionTracking = async _ref3 => {
    let {
      fireEvent,
      waitFor,
      getByRole,
      getByTestId,
      expectedOptLabel
    } = _ref3;
    fireEvent.click(getByRole('link', {
      name: /spelpaus24/i
    }));
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'Spelpaus24',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'Spelpaus24 should be tracked');
    fireEvent.click(getByRole('link', {
      name: /självtest/i
    }));
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'Självtest',
      opt_label: expectedOptLabel,
      opt_value: 0
    })).eql(true, 'Självtest should be tracked');
    fireEvent.click(getByTestId('sound-top-bar'));
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'Ljud_på',
      opt_label: expectedOptLabel,
      opt_value: 0
    })).eql(true, 'Ljud_på should be tracked');
    dispatchCustomEvent('SOUND_STATUS', true);
    fireEvent.click(getByTestId('sound-top-bar'));
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'Ljud_av',
      opt_label: expectedOptLabel,
      opt_value: 0
    })).eql(true, 'Ljud_av should be tracked');
    dispatchCustomEvent('SOUND_STATUS', false);
    await waitFor(() => getByTestId('info-top-bar'));
    fireEvent.click(getByTestId('info-top-bar'));
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'Info',
      opt_label: expectedOptLabel,
      opt_value: 0
    })).eql(true, 'Info should be tracked');
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'flik-spelguide',
      opt_label: expectedOptLabel,
      opt_value: 0
    })).eql(true, 'flik-spelguide should be tracked');
    fireEvent.click(getByRole('link', {
      name: /vinstplan/i
    }));
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'flik-vinstplan',
      opt_label: expectedOptLabel,
      opt_value: 0
    })).eql(true, 'flik-vinstplan should be tracked');
    fireEvent.click(getByTestId('close-top-bar'));
    should(trackEventSpy.calledWithExactly({
      category: 'ticket_topBar',
      action: 'Stäng',
      opt_label: expectedOptLabel,
      opt_value: 0
    })).eql(true, 'Stäng should be tracked');
  };
  const testLeiaEventError = (eventName, detail) => {
    dispatchCustomEvent(eventName, detail);
    should(ticketUtilityErrorLogger.calledWithExactly("LEIA ERROR - eventType: ".concat(detail.eventType, ", error: ").concat(detail.event, ", gameCode: ").concat(detail.gameName, ", gameMode: ").concat(detail.gameMode))).eql(true);
  };
  const shouldLogSoundStatus = _ref4 => {
    let {
      type,
      hasSoundDefaultOn,
      soundStatus,
      usersSavedSoundStatus
    } = _ref4;
    should(ticketUtilityInfoLogger.getCall(-1).args[0]).eql("SoundStatus: ".concat(soundStatus, ", DefaultSoundStatus: ").concat(hasSoundDefaultOn, ", UsersSavedSoundStatus: ").concat(usersSavedSoundStatus, ", GameCode: ").concat(type));
  };
  return {
    beforeStubs,
    afterStubs,
    beforeEachStubs,
    afterEachStubs,
    testUtils,
    testOpenGame,
    renderGame,
    renderGameAsync,
    dispatchCustomEvent,
    testBetId,
    testLeiaEventError,
    testTopbarActionTracking,
    shouldLogSoundStatus
  };
};
setGlobal('svs.ticketgames.ticketUtility.testUtils', testUtils);

 })(window);